import { PolicyCategory } from "@/openapi/generated";

export type PolicyWithCategory = {
  category?: PolicyCategory | null;
};

/** Card-payment-only policy; shown in add-card flow, not in waiver lists. */
export function isSurchargeDisclaimerPolicy(
  policy: PolicyWithCategory,
): boolean {
  return policy.category === PolicyCategory.SurchargeDisclaimer;
}

/** Shown only to choreographers, not on the parent waiver list. */
export function isChoreographerAgreementPolicy(
  policy: PolicyWithCategory,
): boolean {
  return policy.category === PolicyCategory.ChoreographerAgreement;
}

export function excludeSurchargeDisclaimerPolicies<T extends PolicyWithCategory>(
  policies: T[] | undefined,
): T[] {
  return (policies ?? []).filter((policy) => !isSurchargeDisclaimerPolicy(policy));
}
